import { getVCObserver } from '@atlaskit/react-ufo/vc';

export const initializeVCObserver = (rootNode: HTMLElement) => {
	const vcObserver = getVCObserver();
	vcObserver.setSSRElement(rootNode);
	vcObserver.setReactRootRenderStart();
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			vcObserver.setReactRootRenderStop();
		});
	});
};
